import { LoadingSpinner as LoadingComponent } from '@almbrand/loadingspinner';
import { ThemeNames } from 'constantsValues/themeNames';
import { useThemeName } from 'hooks/index';
import styles from './LoadingSpinner.module.scss';

export const LoadingSpinner = () => {
	const themeName = useThemeName();

	return (
		<div className={styles.LoadingSpinner}>
			<LoadingComponent
				color={themeName === ThemeNames.almbrand ? 'supportive-3' : 'primary'}
				style='slow'
				type='circle'
			/>
		</div>
	);
};
